"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkmarkCircle = exports.iconName = exports.paths = void 0;
exports.paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M4 12c0-4.4183 3.5817-8 8-8s8 3.5817 8 8-3.5817 8-8 8-8-3.5817-8-8zm8-10C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10 5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10zm4.551 5.5066-5.9727 6.0047L7.419 10.335l-1.418 1.4104 4.5773 4.6019L17.969 8.917l-1.418-1.4104z" } }];
exports.iconName = 'checkmark-circle';
exports.checkmarkCircle = { iconName: exports.iconName, paths: exports.paths };
exports.default = exports.paths;
